<template>
  <Modal title="分配外教运营" v-model="visible">
    <Form ref="assignAdviserForm" class="form"
      :model="adviserParam" :rules="adviserRule"
      :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="老师">
            <Tag v-for="item in tchList" :key="item.id" :name="item.id" >
              {{ item.id + ' - ' + item.firstName + ' ' + item.lastName }}
            </Tag>
          </Form-item>
        </Col>
        <Col :span="16">
          <Form-item label="外教运营" prop="studyAdviserId">
            <AdminUserSelect adminGroupCode="tchStudyAdviser"
              v-model="adviserParam.studyAdviserId"></AdminUserSelect>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingAssignAdviser" @click="assignAdviser">分配</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'AssignTchStudyAdviserModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchList: {
        type: Array
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingAssignAdviser: false,
        adviserParam: {
          studyAdviserId: ''
        },
        adviserRule: {
          studyAdviserId: [
            { type: 'integer', required: true, message: '请选择外教运营', trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      assignAdviser () {
        let self = this

        self.$refs.assignAdviserForm.validate((valid) => {
          if (!valid) {
            return
          }
          let idList = self.tchList.map(function (element) {
            return element.id
          })
          self.loadingAssignAdviser = true
          let params = {ids: idList.join(','), studyAdviserId: self.adviserParam.studyAdviserId}
          self.$http.get('/tch/updateStudyAdviser', {params: params}).then(function (res) {
            self.successCallback()
            self.visible = false
            self.loadingAssignAdviser = false
          }).catch(function (e) {
            self.visible = false
            self.loadingAssignAdviser = false
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this.adviserParam.studyAdviserId = ''
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AssignTchStudyAdviserModal.vue?415f9d8f